import React, { PropsWithChildren } from "react";
import { X } from "lucide-react";
import Button from "../Button";

interface Props {
    onClose?: () => void;
    title?: string;
    isHidden?: boolean;
    withHeight80vh?: boolean;
    width?: "medium" | "small";
}

const Modal: React.FC<PropsWithChildren<Props>> = ({
    children,
    onClose,
    title,
    isHidden,
    withHeight80vh = false,
    width,
}) => {
    return (
        <div className={`modal ${isHidden ? "hidden" : ""}`}>
            <div className="modal-overlay">
                <div className={`modal__container ${width && `modal__block--${width}`}`}>

                    {onClose && (
                        <Button className="modal__close" onClick={onClose}>
                            <X size={16} aria-hidden="true" />
                        </Button>
                    )}
                    {title ? <p className="modal__title h2 text-center margin-bottom--3">{title}</p> : null}
                    <div className={`modal__content ${withHeight80vh ? "modal__content_height--80vh" : ""}`}>
                        {children}
                    </div>
                </div>
            </div>
        </div>
    );
};
export default Modal;
